// PagosFormulario.jsx
import React, { useEffect, useState, useContext } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useFormContext } from "../context/FormContext";
import { AuthContext } from "../context/authContext.jsx";
import { Select_simple } from "../components/ui";
import { Modal } from "./ui/Modal";

const parseDateLocal = (dateStr) => {
    if (!dateStr) return null;
    if (dateStr instanceof Date) return dateStr;
    const parts = dateStr.split('T')[0].split('-');
    if (parts.length !== 3) return new Date(dateStr);
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
};

const OPCIONES_PORCENTAJE = {
    ANTICIPO: [
        { value: '30', label: '30%' },
        { value: '35', label: '35%' },
        { value: '50', label: '50%' },
        { value: '100', label: '100%' }
    ],
    SEGUNDO_PAGO_50: [
        { value: '50', label: '50%' }
    ],
    SEGUNDO_PAGO_30: [
        { value: '35', label: '35%' }
    ],
    TERCER_PAGO: [
        { value: '35', label: '35%' }
    ],
    TERCER_PAGO_30: [
        { value: '30', label: '30%' }
    ],
    ADENDA: [
        { value: '100', label: '100%' }
    ]
};

const inputClasses = `w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500
                      dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400`;

const restaurarCursor = (input, rawValue, cursorPos) => {
    setTimeout(() => {
        if (!input) return;
        const digitosAntes = (rawValue.substring(0, cursorPos).match(/\d/g) || []).length;
        const formatted = input.value;
        let digitosVistos = 0;
        let nuevaPos = 0;
        for (let i = 0; i < formatted.length && digitosVistos < digitosAntes; i++) {
            if (/\d/.test(formatted[i])) {
                digitosVistos++;
            }
            nuevaPos = i + 1;
        }
        input.setSelectionRange(nuevaPos, nuevaPos);
    }, 0);
};
const headerClasses = `py-2 px-4 font-semibold text-left border-b border-gray-300
                       dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600`;
const rowClasses = `py-2 px-4 border-b border-gray-200 dark:border-gray-700`;

const formatNumberArgentino = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return num.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const parseNumberArgentino = (value) => {
    if (!value) return '';
    const cleaned = value.replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? '' : parsed;
};

const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};

const PagosFormulario = () => {
    const { formA, formC, updateField } = useFormContext();
    const { datosGenerales = {}, array_obras_expediente = [] } = formA;
    const {
        arrayPagosMejoras = [],
        arrayPagosMicrocreditos = [],
        arrayPagosProyectos = [],
        arrayPagosIntervencionSocial = [],
        arrayPagosCapacitaciones = [],
        porcentaje_parcial_2do_pago: porcentajeParcial2doPago,
        porcentaje_parcial_3er_pago: porcentajeParcial3erPago,
        arrayMediciones = [],
        porcentaje_gastos_operativos = ''
    } = formC || {};

    const areaResponsable = datosGenerales?.area_responsable;
    const tieneRendicion = array_obras_expediente?.some(exp => exp && exp.objeto_o === 'Rendición');

    // Confirmación al cambiar la Fecha de Pago de un pago YA REALIZADO (tiene
    // nro_instruccion) en Mejoras: { index, date } pendiente de confirmar. El
    // aviso existe porque esa fecha alimenta la ventana de 90 días de la alerta,
    // así que corregirla mueve el vencimiento de un pago que ya se hizo.
    const [fechaPagoRealizadaPendiente, setFechaPagoRealizadaPendiente] = useState(null);

    // La Fecha de Pago de MEJORAS queda congelada una vez que la alerta se
    // resolvió con una PV (ciclo 2 en adelante): la PV se emitió sobre esa fecha
    // y corregirla dejaría la alerta mintiendo. El backend lo bloquea igual (400
    // al guardar); esto es para que el usuario no intente cambiarla. Si la
    // consulta falla NO se bloquea la UI: el guard del backend sigue actuando.
    const { token } = useContext(AuthContext) || {};
    const [alertaBloqueaFecha, setAlertaBloqueaFecha] = useState(false);
    const [alertaBloqueaDetalle, setAlertaBloqueaDetalle] = useState(null);
    const idObraAlertas = datosGenerales?.id;
    useEffect(() => {
        if (areaResponsable !== 'ÁREA DE MEJORAS' || !idObraAlertas) {
            setAlertaBloqueaFecha(false);
            setAlertaBloqueaDetalle(null);
            return;
        }
        let cancelado = false;
        (async () => {
            try {
                const response = await fetch(`/api/alertas-mejoramientos/obra/${idObraAlertas}`, {
                    headers: token ? { 'Authorization': `Bearer ${token}` } : {}
                });
                if (!response.ok) return;
                const body = await response.json();
                if (cancelado) return;
                setAlertaBloqueaFecha(!!body?.data?.bloqueaCambioFecha);
                setAlertaBloqueaDetalle(body?.data || null);
            } catch (error) {
                console.error('No se pudo consultar el estado de la alerta de Mejoramientos:', error);
            }
        })();
        return () => { cancelado = true; };
    }, [areaResponsable, idObraAlertas, token]);

    // Sincronizar cantidad de filas adenda en PROYECTOS / INTERVENCIÓN SOCIAL con el expediente
    useEffect(() => {
        const esProyectos = areaResponsable === 'ÁREA DE PROYECTOS';
        const esIntervencion = areaResponsable === 'ÁREA DE INTERVENCIÓN SOCIAL';
        if (!esProyectos && !esIntervencion) return;
        const pagosActuales = esProyectos ? (arrayPagosProyectos || []) : (arrayPagosIntervencionSocial || []);
        const adendasEnExp = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda').length;
        const noAdenda = pagosActuales.filter(p => p.tipo_pago !== 'adenda');
        const adendasActuales = pagosActuales.filter(p => p.tipo_pago === 'adenda');

        if (adendasActuales.length === adendasEnExp) return;

        const nuevasAdendas = Array.from({ length: adendasEnExp }, (_, i) => {
            const existente = adendasActuales[i];
            return existente || {
                tipo_pago: "adenda", total_adenda: '', monto: '', porc_pagado: '',
                fecha_pago: null, nro_instruccion: '', porc_avance_obra: '', fecha_certificacion: null
            };
        });
        updateField('formC', esProyectos ? 'arrayPagosProyectos' : 'arrayPagosIntervencionSocial', null, [...noAdenda, ...nuevasAdendas]);
    }, [array_obras_expediente, arrayPagosProyectos, arrayPagosIntervencionSocial, areaResponsable, updateField]);

    const calcularAvanceAcumulado = () => {
        if (!arrayMediciones || arrayMediciones.length === 0) return 0;
        const ultima = arrayMediciones[arrayMediciones.length - 1];
        return parseFloat(ultima.porcentaje_avance) || 0;
    };

    const getEstadoPagosPorAvance = (avanceAcumulado) => {
        return {
            anticipo: true,
            segundoPago: true,
            tercerPago: true,
            avanceAcumulado: avanceAcumulado
        };
    };

    const actualizarPorcentajes = (pagos) => {
        if (!Array.isArray(pagos)) return [];
        const esNumeroValido = (valor) => !isNaN(parseFloat(valor)) && isFinite(valor);

        const anticipo = parseFloat(pagos[0]?.porc_pago || 0);
        const montoConveniado = parseFloat(datosGenerales?.monto_obra || 0);

        const segundoPagoValido = esNumeroValido(pagos[1]?.porc_pago) ? parseFloat(pagos[1].porc_pago) : 0;
        const tercerPagoValido = esNumeroValido(pagos[2]?.porc_pago) ? parseFloat(pagos[2].porc_pago) : 0;

        const adendaObj = array_obras_expediente?.find(exp => exp && exp.objeto_o === 'Adenda');
        const totalAdenda = parseFloat(adendaObj?.monto_adenda || 0);

        const debeHabilitarAdenda = (
            anticipo === 100 ||
            (anticipo === 50 && segundoPagoValido === 50) ||
            (anticipo === 30 && (segundoPagoValido + tercerPagoValido) === 70) ||
            (anticipo === 35 && (segundoPagoValido + tercerPagoValido) === 65)
        );

        if (!anticipo) {
            return pagos.map((pago, i) => pago ? {
                ...pago,
                disabled: i !== 0 || pago.tipo_pago === 'adenda',
                monto: '0',
                porc_pago: ''
            } : null).filter(Boolean);
        }

        return pagos.map((pago, i) => {
            if (!pago) return null;

            if (pago.tipo_pago === 'adenda') {
                return {
                    ...pago,
                    disabled: !debeHabilitarAdenda,
                    monto: debeHabilitarAdenda ? (pago.monto || '0') : '0',
                    porc_pago: debeHabilitarAdenda ? (pago.porc_pago || '') : ''
                };
            }

            if (anticipo === 50) {
                if (i === 0) {
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.50).toFixed(2),
                        porc_pago: '50'
                    };
                }
                if (i === 1) {
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.50).toFixed(2),
                        porc_pago: '50'
                    };
                }
                return {
                    ...pago,
                    disabled: true,
                    monto: '0',
                    porc_pago: ''
                };
            }

            if (anticipo === 35) {
            if (i === 0) {
                return {
                    ...pago,
                    disabled: false,
                    monto: (montoConveniado * 0.35).toFixed(2),
                    porc_pago: '35'
                };
            }
            if (i === 1) {
                return {
                    ...pago,
                    disabled: false,
                    monto: (montoConveniado * 0.35).toFixed(2),
                    porc_pago: '35'
                };
            }
            if (i === 2) {
                return {
                    ...pago,
                    disabled: false,
                    monto: (montoConveniado * 0.30).toFixed(2),
                    porc_pago: '30'
                };
            }
        }

        if (anticipo === 30) {
                if (i === 0) {
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.30).toFixed(2),
                        porc_pago: '30'
                    };
                }
                if (i === 1) {
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.35).toFixed(2),
                        porc_pago: '35'
                    };
                }
                if (i === 2) {
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.35).toFixed(2),
                        porc_pago: '35'
                    };
                }
            }

            return pago;
        }).filter(Boolean);
    };

    const generarArrayPruebasProyectos = () => {
        let pagos = [];
        let pagosFuente = [];

        if (areaResponsable === 'ÁREA DE PROYECTOS') {
            pagosFuente = arrayPagosProyectos || [];
        } else if (areaResponsable === 'ÁREA DE MEJORAS') {
            pagosFuente = arrayPagosMejoras || [];
        } else if (areaResponsable === 'ÁREA DE MICROCRÉDITOS') {
            pagosFuente = arrayPagosMicrocreditos || [];
        } else if (areaResponsable === 'ÁREA DE INTERVENCIÓN SOCIAL') {
            pagosFuente = arrayPagosIntervencionSocial || [];
        } else if (areaResponsable === 'ÁREA DE CAPACITACIONES') {
            pagosFuente = arrayPagosCapacitaciones || [];
        }

        if (Array.isArray(pagosFuente) && pagosFuente.length > 0) {
            if (Array.isArray(pagosFuente[0])) {
                pagos = pagosFuente[0];
            } else {
                pagos = pagosFuente;
            }
        }

        // Microcréditos no tiene Adenda
        if (areaResponsable === 'ÁREA DE MICROCRÉDITOS') {
            pagos = pagos.filter(p => p.tipo_pago !== 'adenda');
        }

        const anticipoSeleccionado = pagos.find(p => p.tipo_pago === 'anticipo')?.porc_pago;

        const pagosFiltrados = (() => {
            const adendasEnExp = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda').length;
            let adendaCount = 0;
            const result = [];
            for (const [sourceIndex, pago] of pagos.entries()) {
                const esAdenda = pago.tipo_pago === 'adenda';
                if (esAdenda) adendaCount++;
                const excedeAdenda = esAdenda && adendaCount > adendasEnExp;

                if (!anticipoSeleccionado) {
                    result.push(excedeAdenda ? { ...pago, disabled: true, porc_pago: '', monto: '', _sourceIndex: sourceIndex } : { ...pago, _sourceIndex: sourceIndex });
                    continue;
                }

                if (pago.tipo_pago === '3er_pago' && anticipoSeleccionado !== '30' && anticipoSeleccionado !== '35') continue;
                if (pago.tipo_pago === '2do_pago' && anticipoSeleccionado === '100') continue;

                result.push(excedeAdenda ? { ...pago, disabled: true, porc_pago: '', monto: '', _sourceIndex: sourceIndex } : { ...pago, _sourceIndex: sourceIndex });
            }
            return result;
        })();

        let adendaRenderCount = 0;
        const pagosMapeados = pagosFiltrados.map((pago, index) => {
            if (typeof pago !== 'object' || pago === null) {
                return {};
            }

            let textoPago = '';
            switch (pago.tipo_pago) {
                case 'total':
                    textoPago = 'Total';
                    break;
                case 'anticipo':
                    textoPago = 'Anticipo';
                    break;
                case '1er_pago':
                    textoPago = '1er pago';
                    break;
                case '2do_pago':
                    textoPago = areaResponsable === 'ÁREA DE CAPACITACIONES' ? '2do pago' : '2do Pago';
                    break;
                case '3er_pago':
                    textoPago = '3er Pago';
                    break;
                case 'adenda':
                    adendaRenderCount++;
                    const adendasEnExp = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda').length;
                    textoPago = adendasEnExp > 1 ? `Adenda ${adendaRenderCount}` : 'Adenda';
                    break;
                default:
                    textoPago = `Pago ${index + 1}`;
            }

            return {
                ...pago,
                tipo_pago: pago.tipo_pago,
                tipo_pago_display: textoPago,
                porc_pago: pago.porc_pago || '',
                monto: pago.monto || '',
                nro_instruccion: pago.nro_instruccion || '',
                porc_avance_obra: pago.porc_avance_obra || '',
                fecha_pago: parseDateLocal(pago.fecha_pago),
                fecha_certificacion: parseDateLocal(pago.fecha_certificacion),
                _sourceIndex: pago._sourceIndex
            };
        });

        return pagosMapeados;
    };

    const aplicarPagoProyectosLike = (currentArray, section, index, field, value) => {
        if (!currentArray[index]) {
            currentArray[index] = {};
        }

        const updatedPago = {
            ...currentArray[index],
            [field]: value
        };

        if (field === 'porc_pago') {
            if (value === '' || isNaN(value)) {
                updatedPago.monto = '';
            } else {
                const montoBase = currentArray[index]?.tipo_pago === 'adenda'
                    ? (() => {
                        const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                        const adendaIdx = currentArray.slice(0, index + 1).filter(p => p?.tipo_pago === 'adenda').length - 1;
                        return parseFloat(adendas[adendaIdx]?.monto_adenda || 0);
                    })()
                    : parseFloat(datosGenerales?.monto_obra || 0);

                const porcentaje = parseFloat(value);
                const montoCalculado = (montoBase * porcentaje / 100).toFixed(2);
                updatedPago.monto = montoCalculado;
            }
        }

        currentArray[index] = updatedPago;

        if (index === 1 && field === 'porc_pago' && value === '' &&
            (currentArray[0]?.porc_pago === '30' || currentArray[0]?.porc_pago === '35') &&
            currentArray[2]) {
            currentArray[2] = {
                ...currentArray[2],
                monto: '0',
                porc_pago: ''
            };
        }

        if (field === 'porc_pago') {
            const updatedArray = actualizarPorcentajes(currentArray);
            updateField('formC', section, null, updatedArray);
            return;
        }

        updateField('formC', section, null, currentArray);
    };

    const handlePagoChangeProyectos = (index, field, value) => {
        console.log("Actualizando pago proyectos (desde PagosFormulario):", { index, field, value });
        const currentArray = Array.isArray(arrayPagosProyectos) ? [...arrayPagosProyectos] : [];
        aplicarPagoProyectosLike(currentArray, 'arrayPagosProyectos', index, field, value);
    };

    const recalcularMontoProyectosLike = (currentArray, section, index) => {
        const pago = currentArray[index];
        if (!pago) return;

        const porcentaje = parseFloat(pago.porc_pago);
        if (!porcentaje || isNaN(porcentaje)) return;

        const montoBase = pago.tipo_pago === 'adenda'
            ? (() => {
                const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                const adendaIdx = currentArray.slice(0, index + 1).filter(p => p?.tipo_pago === 'adenda').length - 1;
                return parseFloat(adendas[adendaIdx]?.monto_adenda || 0);
            })()
            : parseFloat(datosGenerales?.monto_obra || 0);

        pago.monto = (montoBase * porcentaje / 100).toFixed(2);
        currentArray[index] = { ...pago };
        updateField('formC', section, null, currentArray);
    };

    const recalcularMontoPago = (index) => {
        const currentArray = Array.isArray(arrayPagosProyectos) ? [...arrayPagosProyectos] : [];
        recalcularMontoProyectosLike(currentArray, 'arrayPagosProyectos', index);
    };

    const recalcularMontoIntervencionSocial = (index) => {
        const currentArray = Array.isArray(arrayPagosIntervencionSocial) ? [...arrayPagosIntervencionSocial] : [];
        recalcularMontoProyectosLike(currentArray, 'arrayPagosIntervencionSocial', index);
    };

    const handlePagoChangeMejoras = (index, field, value) => {
        console.log("Actualizando pago mejoras (desde PagosFormulario):", { index, field, value });
        const currentArray = Array.isArray(arrayPagosMejoras) ? [...arrayPagosMejoras] : [];

        if (!currentArray[index]) {
            currentArray[index] = {};
        }

        if (field === 'monto' || field === 'total_adenda') {
            currentArray[index][field] = value === '' ? '' : Number(value);
        } else if (field === 'fecha_pago' || field === 'fecha_certificacion') {
            currentArray[index][field] = value ? new Date(value) : null;
        } else if (field === 'porc_pago') {
            currentArray[index][field] = value;
            if (value === '100') {
                if (currentArray[index]?.tipo_pago === 'adenda') {
                    const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                    const adendaIdx = currentArray.slice(0, index + 1).filter(p => p?.tipo_pago === 'adenda').length - 1;
                    const montoBase = parseFloat(adendas[adendaIdx]?.monto_adenda || 0);
                    currentArray[index].monto = montoBase.toFixed(2);
                } else {
                    currentArray[index].monto = parseFloat(datosGenerales?.monto_obra || 0).toFixed(2);
                }
            } else {
                currentArray[index].monto = '';
            }
        } else {
            currentArray[index][field] = value;
        }

        updateField('formC', 'arrayPagosMejoras', null, currentArray);
    };

    const handlePagoChangeMicrocreditos = (index, field, value) => {
        console.log("Actualizando pago microcreditos (desde PagosFormulario):", { index, field, value });
        const currentArray = Array.isArray(arrayPagosMicrocreditos) ? [...arrayPagosMicrocreditos] : [];

        if (!currentArray[index]) {
            currentArray[index] = {};
        }

        if (field === 'monto' || field === 'porc_avance_obra') {
            currentArray[index][field] = value === '' ? '' : Number(value);
        } else if (field === 'fecha_pago' || field === 'fecha_certificacion') {
            currentArray[index][field] = value ? new Date(value) : null;
        } else if (field === 'porc_pago') {
            currentArray[index][field] = value;
            if (value === '100') {
                currentArray[index].monto = parseFloat(datosGenerales?.monto_obra || 0).toFixed(2);
            } else {
                currentArray[index].monto = '';
            }
        } else {
            currentArray[index][field] = value;
        }

        updateField('formC', 'arrayPagosMicrocreditos', null, currentArray);
    };

    const handlePagoChangeIntervencionSocial = (index, field, value) => {
        console.log("Actualizando pago intervencion social (desde PagosFormulario):", { index, field, value });
        const currentArray = Array.isArray(arrayPagosIntervencionSocial) ? [...arrayPagosIntervencionSocial] : [];
        aplicarPagoProyectosLike(currentArray, 'arrayPagosIntervencionSocial', index, field, value);
    };

    const handlePagoChangeCapacitaciones = (index, field, value) => {
        console.log("Actualizando pago capacitaciones (desde PagosFormulario):", { index, field, value });
        const currentArray = Array.isArray(arrayPagosCapacitaciones) ? [...arrayPagosCapacitaciones] : [];

        if (!currentArray[index]) {
            currentArray[index] = {};
        }

        if (field === 'porc_pago') {
            currentArray[index][field] = value;
            if (value) {
                const porcentaje = parseFloat(value);
                if (currentArray[index]?.tipo_pago === 'adenda') {
                    const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                    const adendaIdx = currentArray.slice(0, index + 1).filter(p => p?.tipo_pago === 'adenda').length - 1;
                    currentArray[index].monto = (parseFloat(adendas[adendaIdx]?.monto_adenda || 0) * porcentaje / 100).toFixed(2);
                } else {
                    const montoBase = parseFloat(datosGenerales?.monto_obra || 0);
                    currentArray[index].monto = (montoBase * porcentaje / 100).toFixed(2);
                }
            } else {
                currentArray[index].monto = '';
            }
        } else {
            currentArray[index][field] = value;
        }

        updateField('formC', 'arrayPagosCapacitaciones', null, currentArray);
    };

    if (!tieneRendicion) {
        return (
            <div className="mt-4 p-4 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-800">
                <h3 className="text-lg font-semibold mb-2 dark:text-white">Formulario de Pagos </h3>
                <p className="text-red-700 dark:text-red-300">
                    {`⚠️ No se puede mostrar el formulario de pagos porque no hay un expediente con objeto 'Rendición'.`}
                </p>
            </div>
        );
    }

    if (areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS') {
        const handleChange = areaResponsable === 'ÁREA DE MEJORAS'
            ? handlePagoChangeMejoras
            : handlePagoChangeMicrocreditos;
        const mostrarFechaCert = areaResponsable !== 'ÁREA DE MICROCRÉDITOS' && datosGenerales?.tipo_subsidio === 'Subsidio a ONG' && datosGenerales?.modalidad !== 'etapa II';
        const gridCols = mostrarFechaCert ? 'grid-cols-6' : 'grid-cols-5';
        const pagosFiltrados = (() => {
            const raw = generarArrayPruebasProyectos();
            if (areaResponsable === 'ÁREA DE MEJORAS') {
                const adendasValidas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda' && parseFloat(exp.monto_adenda) > 0);
                let adendaCount = 0;
                return raw.filter(p => {
                    if (p.tipo_pago !== 'adenda') return true;
                    adendaCount++;
                    return adendaCount <= adendasValidas.length;
                });
            }
            return raw;
        })();

        const getAreaTitle = () => {
            switch (areaResponsable) {
                case 'ÁREA DE MEJORAS': return 'MEJORAS';
                case 'ÁREA DE MICROCRÉDITOS': return 'MICROCRÉDITOS';
                case 'ÁREA DE INTERVENCIÓN SOCIAL': return 'INTERVENCIÓN SOCIAL';
                default: return '';
            }
        };

        const OPCIONES_100 = [{ value: '100', label: '100%' }];

        const montoEsperado = (pago, index) => {
            if (!pago?.porc_pago) return null;
            if (areaResponsable === 'ÁREA DE MEJORAS') {
                if (pago.tipo_pago === 'adenda') {
                    const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                    const adendaIdx = (pagosFiltrados || []).slice(0, index).filter(p => p?.tipo_pago === 'adenda').length;
                    return parseFloat(adendas[adendaIdx]?.monto_adenda || 0).toFixed(2);
                }
                return parseFloat(datosGenerales?.monto_obra || 0).toFixed(2);
            }
            if (areaResponsable === 'ÁREA DE MICROCRÉDITOS') {
                return parseFloat(datosGenerales?.monto_obra || 0).toFixed(2);
            }
            if (pago.tipo_pago === 'adenda') {
                const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                const adendaIdx = (pagosFiltrados || []).slice(0, index).filter(p => p?.tipo_pago === 'adenda').length;
                const montoAdenda = parseFloat(adendas[adendaIdx]?.monto_adenda || 0);
                return (montoAdenda * parseFloat(pago.porc_pago) / 100).toFixed(2);
            }
            return (parseFloat(datosGenerales?.monto_obra || 0) * parseFloat(pago.porc_pago) / 100).toFixed(2);
        };

        const recalcularMonto = (index) => {
            handleChange(index, 'porc_pago', '100');
        };

        return (
            <div className="mt-4 overflow-x-auto">
                <h3 className="text-lg font-semibold mb-2 dark:text-white">
                    Formulario de Pagos {getAreaTitle() ? ` - ${getAreaTitle()}` : ''}
                </h3>
                {alertaBloqueaFecha && (
                    <div className="mb-3 p-3 text-sm rounded-md border border-amber-300 bg-amber-50 text-amber-800 dark:bg-amber-900/20 dark:border-amber-700 dark:text-amber-200">
                        La alerta de Mejoramientos ya fue resuelta{alertaBloqueaDetalle?.nroPv ? ` con la PV ${alertaBloqueaDetalle.nroPv}` : ''}: la <strong>Fecha de Pago</strong> no se puede modificar.
                    </div>
                )}
                <div className="w-full">
                    {/* Header */}
                    <div className={`grid ${gridCols} text-sm lg:text-base`}>
                        <div className={headerClasses}>Pago</div>
                        {(areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS') && (
                            <div className={headerClasses}>Porcentaje</div>
                        )}
                        <div className={headerClasses}>Monto</div>
                        <div className={headerClasses}>Fecha de Pago</div>
                        <div className={headerClasses}>Nro. Instrucción</div>
                        {mostrarFechaCert && <div className={headerClasses}>Fecha Certificación</div>}
                    </div>

                    {/* Rows */}
                    {pagosFiltrados.map((pago, index) => {
                        return (
                            <div key={`${pago.tipo_pago}-${index}`} className={`grid ${gridCols} items-center`}>
                                <div className={`${rowClasses} font-semibold dark:text-white`}>
                                    {pago.tipo_pago_display || capitalize(pago.tipo_pago)}
                                </div>
                                {(areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS') && (
                                    <div className={rowClasses}>
                                        <Select_simple
                                            value={pago.porc_pago || ''}
                                            onChange={(e) => handleChange(index, 'porc_pago', e.target.value)}
                                            options={OPCIONES_100}
                                            placeholder="Seleccionar..."
                                            disabled={!!pago.fecha_pago}
                                        />
                                    </div>
                                )}
                                <div className={`${rowClasses} flex gap-1 items-center`}>
                                    <input
                                        type="text"
                                        value={formatNumberArgentino(pago.monto || '')}
                                        readOnly
                                        className={inputClasses + ' flex-1 min-w-0 bg-gray-100 dark:bg-gray-600 cursor-default'}
                                        placeholder="0,00"
                                        tabIndex={-1}
                                    />
                                    {(areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS') && (
                                        <button
                                            type="button"
                                            onClick={() => recalcularMonto(index)}
                                            className="p-1.5 text-blue-600 hover:text-blue-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded transition-colors"
                                            title="Recalcular monto según monto de obra"
                                        hidden={!(pago.porc_pago && pago.monto && Math.abs(Number(montoEsperado(pago, index)) - Number(pago.monto)) > 0.01)}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    )}
                                </div>
                                <div className={rowClasses}>
                                    <DatePicker
                                        selected={pago.fecha_pago}
                                        onChange={(date) => {
                                            const esMejoras = areaResponsable === 'ÁREA DE MEJORAS';
                                            const tieneInstruccion = String(pago.nro_instruccion || '').trim() !== '';
                                            const cambia = String(date || '') !== String(pago.fecha_pago || '');
                                            if (esMejoras && tieneInstruccion && date && cambia) {
                                                setFechaPagoRealizadaPendiente({ index, date });
                                            } else {
                                                handleChange(index, 'fecha_pago', date);
                                            }
                                        }}
                                        disabled={areaResponsable === 'ÁREA DE MEJORAS' && alertaBloqueaFecha}
                                        dateFormat="dd/MM/yyyy"
                                        className={inputClasses}
                                        placeholderText="DD/MM/AAAA"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />
                                </div>
                                <div className={rowClasses}>
                                    <input
                                        type="text"
                                        value={pago.nro_instruccion || ''}
                                        onChange={(e) => handleChange(index, 'nro_instruccion', e.target.value)}
                                        className={inputClasses}
                                        placeholder="N° de instrucción"
                                    />
                                </div>
                                {mostrarFechaCert && (
                                <div className={rowClasses}>
                                    <DatePicker
                                        selected={pago.fecha_certificacion}
                                        onChange={(date) => handleChange(index, 'fecha_certificacion', date)}
                                        dateFormat="dd/MM/yyyy"
                                        className={inputClasses}
                                        placeholderText="DD/MM/AAAA"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />
                                </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                <Modal
                    isOpen={!!fechaPagoRealizadaPendiente}
                    onClose={() => setFechaPagoRealizadaPendiente(null)}
                    title="Modificar un pago realizado"
                    maxWidth="max-w-md"
                >
                    <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
                        Este pago ya tiene un <strong>N° de instrucción</strong> cargado (pago realizado).
                    </p>
                    <p className="text-sm text-gray-700 dark:text-gray-300">
                        Si cambiás la <strong>Fecha de Pago</strong>, se reprograma la ventana de 90 días de la alerta de Mejoramientos. ¿Confirmás el cambio?
                    </p>
                    <div className="flex justify-end gap-3 mt-5">
                        <button
                            type="button"
                            onClick={() => setFechaPagoRealizadaPendiente(null)}
                            className="px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                const pend = fechaPagoRealizadaPendiente;
                                setFechaPagoRealizadaPendiente(null);
                                if (pend) handleChange(pend.index, 'fecha_pago', pend.date);
                            }}
                            className="px-4 py-2 rounded-md bg-blue-500 text-white hover:bg-blue-600"
                        >
                            Confirmar cambio
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }

    if (areaResponsable === 'ÁREA DE CAPACITACIONES') {
        const gridCols = 'grid-cols-5';
        const tieneAdendaExp = (array_obras_expediente || []).some(exp => exp && exp.objeto_o === 'Adenda');
        const pagosFiltrados = generarArrayPruebasProyectos().filter(p => !(p.tipo_pago === 'adenda' && !tieneAdendaExp));

        const opcionesPorc = (pago) => pago.tipo_pago === 'adenda'
            ? [{ value: '100', label: '100%' }]
            : [{ value: '50', label: '50%' }];

        const montoEsperado = (pago, index) => {
            if (!pago?.porc_pago) return null;
            const porcentaje = parseFloat(pago.porc_pago);
            if (!porcentaje || isNaN(porcentaje)) return null;
            if (pago.tipo_pago === 'adenda') {
                const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                const adendaIdx = (pagosFiltrados || []).slice(0, index).filter(p => p?.tipo_pago === 'adenda').length;
                return parseFloat(adendas[adendaIdx]?.monto_adenda || 0).toFixed(2);
            }
            return (parseFloat(datosGenerales?.monto_obra || 0) * porcentaje / 100).toFixed(2);
        };

        const recalcularMonto = (index) => {
            const pago = pagosFiltrados[index];
            const porc = pago?.porc_pago || (pago?.tipo_pago === 'adenda' ? '100' : '50');
            handlePagoChangeCapacitaciones(index, 'porc_pago', porc);
        };

        return (
            <div className="mt-4 overflow-x-auto">
                <h3 className="text-lg font-semibold mb-2 dark:text-white">
                    Formulario de Pagos - CAPACITACIONES
                </h3>
                <div className="w-full">
                    {/* Header */}
                    <div className={`grid ${gridCols} text-sm lg:text-base`}>
                        <div className={headerClasses}>Pago</div>
                        <div className={headerClasses}>Porcentaje pago</div>
                        <div className={headerClasses}>Monto</div>
                        <div className={headerClasses}>Fecha de Pago</div>
                        <div className={headerClasses}>Nro. Instrucción</div>
                    </div>

                    {/* Rows */}
                    {pagosFiltrados.map((pago, index) => {
                        const handlerIndex = pago._sourceIndex ?? index;
                        return (
                            <div key={`${pago.tipo_pago}-${index}`} className={`grid ${gridCols} items-center`}>
                                {/* Columna 1: Pago */}
                                <div className={`${rowClasses} font-semibold dark:text-white`}>
                                    {pago.tipo_pago_display || capitalize(pago.tipo_pago)}
                                </div>
                                {/* Columna 2: Porcentaje */}
                                <div className={rowClasses}>
                                    <Select_simple
                                        value={pago.porc_pago || ''}
                                        onChange={(e) => handlePagoChangeCapacitaciones(handlerIndex, 'porc_pago', e.target.value)}
                                        options={opcionesPorc(pago)}
                                        placeholder="Seleccionar..."
                                        disabled={!!pago.fecha_pago}
                                    />
                                </div>
                                {/* Columna 3: Monto */}
                                <div className={`${rowClasses} flex gap-1 items-center`}>
                                    <input
                                        type="text"
                                        value={formatNumberArgentino(pago.monto || '')}
                                        readOnly
                                        className={inputClasses + ' flex-1 min-w-0 bg-gray-100 dark:bg-gray-600 cursor-default'}
                                        placeholder="0,00"
                                        tabIndex={-1}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => recalcularMonto(handlerIndex)}
                                        className="p-1.5 text-blue-600 hover:text-blue-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded transition-colors"
                                        title="Recalcular monto según porcentaje y monto de obra"
                                        hidden={!(pago.porc_pago && pago.monto && Math.abs(Number(montoEsperado(pago, index)) - Number(pago.monto)) > 0.01)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                {/* Columna 4: Fecha de Pago */}
                                <div className={rowClasses}>
                                    <DatePicker
                                        selected={pago.fecha_pago}
                                        onChange={(date) => handlePagoChangeCapacitaciones(handlerIndex, 'fecha_pago', date)}
                                        dateFormat="dd/MM/yyyy"
                                        className={inputClasses}
                                        placeholderText="DD/MM/AAAA"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />
                                </div>
                                {/* Columna 5: Nro. Instrucción */}
                                <div className={rowClasses}>
                                    <input
                                        type="text"
                                        value={pago.nro_instruccion || ''}
                                        onChange={(e) => handlePagoChangeCapacitaciones(handlerIndex, 'nro_instruccion', e.target.value)}
                                        className={inputClasses}
                                        placeholder="N° de instrucción"
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    if (areaResponsable === 'ÁREA DE PROYECTOS' || areaResponsable === 'ÁREA DE INTERVENCIÓN SOCIAL') {
        const esIntervencionSocial = areaResponsable === 'ÁREA DE INTERVENCIÓN SOCIAL';
        const pagosActivos = esIntervencionSocial ? (arrayPagosIntervencionSocial || []) : arrayPagosProyectos;
        const handlePago = esIntervencionSocial ? handlePagoChangeIntervencionSocial : handlePagoChangeProyectos;
        const recalcularMonto = esIntervencionSocial ? recalcularMontoIntervencionSocial : recalcularMontoPago;
        const titulo = esIntervencionSocial ? 'Formulario de Pagos - INTERVENCIÓN SOCIAL' : 'Formulario de Pagos - OBRAS';
        const avanceAcumulado = calcularAvanceAcumulado();
        const gridCols = 'grid-cols-5';
        const pagosFiltrados = generarArrayPruebasProyectos();

        const anticipoFecha = pagosActivos?.[0]?.fecha_pago;
        const bloqueadoGlobal = anticipoFecha instanceof Date || (typeof anticipoFecha === 'string' && anticipoFecha.length > 0);

        const montoEsperado = (pago, index) => {
            if (!pago?.porc_pago) return null;
            const porcentaje = parseFloat(pago.porc_pago);
            if (!porcentaje || isNaN(porcentaje)) return null;
            const montoBase = pago.tipo_pago === 'adenda'
                ? (() => {
                    const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                    const adendaIdx = (pagosFiltrados || []).slice(0, index).filter(p => p?.tipo_pago === 'adenda').length;
                    return parseFloat(adendas[adendaIdx]?.monto_adenda || 0);
                })()
                : parseFloat(datosGenerales?.monto_obra || 0);
            return (montoBase * porcentaje / 100).toFixed(2);
        };

        return (
            <div className="mt-4 overflow-x-auto">
                <div className="flex justify-between items-center mb-2">
                    <h3 className="text-lg font-semibold dark:text-white">{titulo}</h3>
                    {!esIntervencionSocial && (
                        <div className="flex items-center gap-2">
                            <span className="text-sm text-gray-600 dark:text-gray-400">Avance de Obra:</span>
                            <span className={`px-3 py-1 rounded-full text-sm font-semibold ${avanceAcumulado > 60 ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300' :
                                avanceAcumulado > 25 ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300' :
                                    'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300'
                                }`}>
                                {avanceAcumulado.toFixed(2)}%
                            </span>
                        </div>
                    )}
                </div>
                <div className="w-full">
                    {/* Header */}
                    <div className={`grid ${gridCols} text-sm lg:text-base`}>
                        <div className={headerClasses}>Pago</div>
                        <div className={headerClasses}>Porcentaje pago</div>
                        <div className={headerClasses}>Monto</div>
                        <div className={headerClasses}>Fecha de Pago</div>
                        <div className={headerClasses}>Nro. Instrucción</div>
                    </div>

                    {/* Rows */}
                    {pagosFiltrados.map((pago, index) => {
                        console.log('Procesando pago (PROYECTOS) en PagosFormulario:', pago);

                        // Omitir el pago de tipo 'adenda' solo si no hay expediente adenda y no está disabled (ya viene manejado desde generarArrayPruebasProyectos)
                        if (pago.tipo_pago === 'adenda' && !array_obras_expediente?.some(exp => exp && exp.objeto_o === 'Adenda') && !pago.disabled) {
                            console.log('Omitiendo pago de adenda (PROYECTOS)');
                        }

                        const handlerIndex = pago._sourceIndex ?? index;
                        return (
                            <div key={`${pago.tipo_pago}-${index}`} className={`grid ${gridCols} items-center`}>
                                {/* Columna 1: Pago */}
                                <div className={`${rowClasses} font-semibold dark:text-white`}>
                                    {pago.tipo_pago_display || pago.tipo_pago}
                                </div>
                                {/* Columna 2: Porcentaje pago */}
                                <div className={rowClasses}>
                                    {(() => {

                                        if (index === 0) {
                                            return (
                                                <Select_simple
                                                    value={pago.porc_pago || ''}
                                                    onChange={(e) => handlePago(handlerIndex, 'porc_pago', e.target.value)}
                                                    options={OPCIONES_PORCENTAJE.ANTICIPO}
                                                    placeholder="Seleccione"
                                                    disabled={bloqueadoGlobal && pago.porc_pago && pago.porc_pago !== ''}
                                                />
                                            );
                                        }

                                        if (pago.tipo_pago === 'adenda') {
                                            if (!pagosActivos[0]?.porc_pago) {
                                                return <span key="complete-pagos" className="text-gray-400">Complete los pagos de la obra primero</span>;
                                            }
                                            return (
                                                <Select_simple
                                                    value={pago.porc_pago || ''}
                                                    onChange={(e) => handlePago(handlerIndex, 'porc_pago', e.target.value)}
                                                    options={OPCIONES_PORCENTAJE.ADENDA}
                                                    placeholder="Seleccione"
                                                    disabled={bloqueadoGlobal && pago.porc_pago && pago.porc_pago !== ''}
                                                />
                                            );
                                        }

                                        if (!pagosActivos[0]?.porc_pago) {
                                            return index === 2 ? (
                                                <span key="espere-anticipo" className="text-gray-400">Se requiere el 2do pago</span>
                                            ) : (
                                                <span key="seleccione-anticipo" className="text-gray-400">Se requiere el anticipo primero</span>
                                            );
                                        }

                                        if (index === 2) {
                                            if (pagosActivos[0]?.porc_pago === '50' || pagosActivos[0]?.porc_pago === '100') {
                                                return <span key="no-aplica" className="text-gray-500">No aplica</span>;
                                            }
                                            if (!pagosActivos[1]?.porc_pago) {
                                                return <span key="complete-segundo" className="text-gray-400">Complete el segundo pago primero</span>;
                                            }
                                            return (
                                                <Select_simple
                                                    value={pago.porc_pago || ''}
                                                    onChange={(e) => handlePago(handlerIndex, 'porc_pago', e.target.value)}
                                                    options={pagosActivos[0]?.porc_pago === '35' ? OPCIONES_PORCENTAJE.TERCER_PAGO_30 : OPCIONES_PORCENTAJE.TERCER_PAGO}
                                                    placeholder="Seleccione"
                                                    disabled={bloqueadoGlobal && pago.porc_pago && pago.porc_pago !== ''}
                                                />
                                            );
                                        }

                                        return (
                                            <Select_simple
                                                value={pago.porc_pago || ''}
                                                onChange={(e) => handlePago(handlerIndex, 'porc_pago', e.target.value)}
                                                options={
                                                    pagosActivos[0]?.porc_pago === '50' ?
                                                        OPCIONES_PORCENTAJE.SEGUNDO_PAGO_50 :
                                                        OPCIONES_PORCENTAJE.SEGUNDO_PAGO_30
                                                }
                                                placeholder="Seleccione"
                                                disabled={bloqueadoGlobal && pago.porc_pago && pago.porc_pago !== ''}
                                            />
                                        );
                                    })()}
                                </div>
                                {/* Columna 3: Monto */}
                                <div className={`${rowClasses} flex gap-1 items-center`}>
                                    <input
                                        type="text"
                                        value={formatNumberArgentino(pago.monto || '')}
                                        readOnly
                                        className={inputClasses + ' flex-1 min-w-0 bg-gray-100 dark:bg-gray-600 cursor-default'}
                                        placeholder="0,00"
                                        tabIndex={-1}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => recalcularMonto(handlerIndex)}
                                        className="p-1.5 text-blue-600 hover:text-blue-800 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded transition-colors"
                                        title="Recalcular monto según porcentaje y monto de obra"
                                        hidden={!(pago.porc_pago && pago.monto && Math.abs(Number(montoEsperado(pago, index)) - Number(pago.monto)) > 0.01)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                                {/* Columna 4: Fecha de Pago */}
                                <div className={rowClasses}>
                                    <DatePicker
                                        selected={pago.fecha_pago}
                                        onChange={(date) => handlePago(handlerIndex, 'fecha_pago', date)}
                                        dateFormat="dd/MM/yyyy"
                                        className={inputClasses}
                                        placeholderText="DD/MM/AAAA"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />
                                </div>
                                {/* Columna 5: Nro. Instrucción */}
                                <div className={rowClasses}>
                                    <input
                                        type="text"
                                        value={pago.nro_instruccion || ''}
                                        onChange={(e) => handlePago(handlerIndex, 'nro_instruccion', e.target.value)}
                                        className={inputClasses}
                                        placeholder="N° de instrucción"
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    return null;
};

export default PagosFormulario;
